export default from './profile-notifications-page';



// WEBPACK FOOTER //
// ./app/containers/profile-notifications-page/index.js